/* eslint-disable no-negated-condition */
/* eslint-disable complexity */
import {useState, useEffect, useRef, useCallback} from 'react';
import {useIntl} from 'react-intl';
import {throttle} from 'lodash-es';
import * as store from '@/store';
import Icon, {IconSize} from '@/components/Icon';
import {CommentNumberSvg, ReadNumberSvg, InfoSvg} from '@/icons';
import {IAiChatPanel, ICommentCount} from '@/interface';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import TagWrap from './TagWrap';
import {leftElResizeContext} from './context';
import styles from './index.module.scss';
import kuPiper from '@/middleware/kuPiper';
import {Popover} from '@baidu/luffy-comp-popover';
import {SvgHiArrow} from '@baidu/luffy-icon';
import RecentBrowseRecordsConfirmDialog from './RecentBrowseRecords';
import sdk from '@/sdk';
import classNames from 'classnames';
import {feLogger, recentBrowseRecordsClick, recentBrowseRecordsHover, reportDocComplainBtn} from '@/buried';
import ViewKnowledgeCoin from './ViewKnowledgeCoin';
import ComplainDialog from '@/components/ComplainDialog';
import CoinBottomBar from '@/assets/svg/bottomCoin.svg?tsx';
import {getIsBaikeRepo} from '@/pages/baike/utils';
import {EDITOR_MODE, PageSecurityIsSelected} from '@/Constant';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import StatisticCount from './StatisticCount';


interface IViewNumberProps {
    title: string;
    icon: React.FunctionComponent;
    number?: number;
}

interface AllRecentBrowseRecords {
    icon: React.FunctionComponent;
    number?: number;
    setIsOpenAllRecentBrowseRecords: React.Dispatch<React.SetStateAction<boolean>>;
    repositoryGuid: string;
    docGuid: string | undefined;
    setcloseRecentBrowseRecords: React.Dispatch<React.SetStateAction<boolean>>;
}


// 未开启情况下的展示信息及评论数信息
function ViewNumber(props: IViewNumberProps) {
    const {title, icon, number = 0} = props;
    return (
        <Tooltip trigger={TooltipTrigger.Hover} content={title}>
            <div className={styles.countNum}>
                <Icon className={styles.icon} svg={icon} size={IconSize.LG} />
                <span>{number}</span>
            </div>
        </Tooltip>
    );
}
// 浏览记录可查看情况下成员的展示信息
function ViewNumberIsLookToMember(props: IViewNumberProps) {
    const {title, icon, number = 0} = props;
    const head = <div>
        <Icon svg={InfoSvg} />
        <span className={styles.recordsTitleText}>最近浏览记录</span>
    </div>;
    const contentText = <div className={styles.contentText}>
        {title}
    </div>;
    return (
        <Popover
            type={'hover'}
            placement={'top-start'}
            headline={head}
            content={contentText}
            withArrow={false}
            className={styles.recordsBox}
            withCloseX={false}
        >
            <div className={styles.countNum}>
                <Icon className={styles.icon} svg={icon} size={IconSize.LG} />
                <span>{number}</span>
            </div>
        </Popover>
    );
}


// 浏览记录可查看情况下管理员及编辑人员的展示信息
function ViewNumberIsLookToAdministrators(props: AllRecentBrowseRecords) {
    const {
        icon,
        number = 0,
        setIsOpenAllRecentBrowseRecords,
        repositoryGuid,
        docGuid,
        setcloseRecentBrowseRecords,
    } = props;
    const [list, setList] = useState<any[]>([]);

    // 点击后跳转全部浏览记录弹窗
    function openConfirmDialog() {
        feLogger(recentBrowseRecordsClick);
        setIsOpenAllRecentBrowseRecords(true);
    }
    // 缩略图内容主体
    function renderSmallBrowseInformation() {
        return (
            <div
                className={classNames(styles.contextBox,
                    `${list.length === 1
                        ? styles.contextBoxOne
                        : null}`,
                    `${list.length === 2
                        ? styles.contextBoxTwo
                        : null}`)}
            >
                {
                    list.map((item: any) => {
                        return (
                            <div key={`${item.userGuid}`} className={styles.context}>
                                <img src={item.avatarUrl} className={styles.imgStyles} />
                                <div className={styles.nickname}>{item.nickname}</div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
    // 获取浏览记录(过滤的)
    async function recentBrowseRecordsAndFilter() {
        if (repositoryGuid) {
            const data = {
                docGuid,
                repositoryGuid: repositoryGuid,
            };
            try {
                const ksServer = await sdk.getKsServer();
                const result = await ksServer.getRecentBrowseRecordsAndFilter(data);
                setList(result);
            } catch (error) {
                if (error.code === 400) {
                    setcloseRecentBrowseRecords(true);
                }
                console.log(error);
            }
        }
    }
    function hoverOnchange(e: any) {
        if (e) {
            feLogger(recentBrowseRecordsHover);
        }
    }
    useEffect(() => {
        recentBrowseRecordsAndFilter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const contentText =
        <div
            className={`${list.length <= 3
                ? styles.smallRecordsBoxToAdministratorsContent
                : styles.recordsBoxToAdministratorsContent}`}
            onClick={openConfirmDialog}
        >
            <div className={styles.recordsTitle}>
                <span className={styles.recordsTitleText}>最近浏览记录</span>
                <div
                    className={`${list.length <= 3
                        ? styles.smallAllRecentBrowseRecords
                        : styles.allRecentBrowseRecords} ${styles.allRecentBrowseRecordsPublic}`}
                >
                    <span>全部</span>
                    <SvgHiArrow />
                </div>
            </div>
            {/* 存放记录使用 */}
            <div className={`${list.length <= 3
                ? styles.smallContentBrowseRecords
                : styles.contentBrowseRecords}`}
            >
                {renderSmallBrowseInformation()}
            </div>
        </div>;
    return (
        <Popover
            type={'hover'}
            placement={'top-start'}
            content={contentText}
            withArrow={false}
            className={`${list.length <= 3
                ? styles.smallRecordsBoxToAdministrators
                : styles.recordsBoxToAdministrators}`}
            withCloseX={false}
            onChange={hoverOnchange}
        >
            <div className={styles.countNum}>
                <Icon className={styles.icon} svg={icon} size={IconSize.LG} />
                <span>{number}</span>
            </div>
        </Popover>
    );
}

export interface IProps {
    editable: boolean;
    curDocument: WizDocument;
    curRepository: Repository;
    isStatNumShow?: boolean;
    curDocCommentCount?: ICommentCount;
    docContentWidth?: {
        width: number;
        left: number;
    };
    rootId?: string;
    curDocKnowledgeCoin: number;
    documentMode: EDITOR_MODE;
    aiChatPanel: IAiChatPanel;
    pageSecuritySettings?: any;
    docWordNum?: {
        totalWordCount: number;
        selectedWordCount?: number;
    };
    demoMode?: boolean;
}

const BottomBar: React.FC<IProps> = ({
    curDocument,
    curRepository,
    editable,
    isStatNumShow,
    curDocCommentCount,
    curDocKnowledgeCoin,
    docContentWidth,
    rootId,
    documentMode: mode,
    aiChatPanel,
    pageSecuritySettings,
    docWordNum,
    demoMode,
}) => {
    const intl = useIntl();
    const commentNum = (curDocCommentCount?.commentAllCount || 0) + (curDocCommentCount?.underlineCommentCount || 0);
    const knowledgeCoinNum = curDocKnowledgeCoin || 0;
    const [isOpenAllRecentBrowseRecords, setIsOpenAllRecentBrowseRecords] = useState(false);
    const [isCloseRecentBrowseRecords, setIsCloseRecentBrowseRecords] = useState(true);
    const [closeRecentBrowseRecords, setcloseRecentBrowseRecords] = useState(false);
    const [complainVisible, setComplainVisible] = useState(false);

    // 是否是百科模式
    const isBaikeRepo = getIsBaikeRepo(curRepository?.repositoryGuid || '');
    const isCardView = store.getData(store.KEYS.IS_CARD_VIEW);

    const leftElRef = useRef<HTMLDivElement | null>(null);
    const [leftElResizeFlag, setLeftElResizeFlag] = useState(0);

    // 判断是否开启最近浏览记录
    useEffect(() => {
        if (pageSecuritySettings && Object.keys(pageSecuritySettings).length) {
            const CloseRecentBrowseRecords = !PageSecurityIsSelected.includes(
                pageSecuritySettings.retrieveStatus
            );
            setIsCloseRecentBrowseRecords(CloseRecentBrowseRecords);
        } else {
            setIsCloseRecentBrowseRecords(true);
        }
    }, [pageSecuritySettings]);

    useEffect(() => {
        const onResizeThrottle = throttle(setLeftElResizeFlag, 100);
        let resizeObserver: ResizeObserver | null = null;
        if (window.ResizeObserver && leftElRef.current) {
            resizeObserver = new window.ResizeObserver(() => {
                onResizeThrottle(val => val + 1);
            });

            resizeObserver.observe(leftElRef.current);
        }

        return () => {
            resizeObserver && resizeObserver.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 底部知识币在一些case不存在，需要手动获取知识币
    const updateKnowledgeCoins = useCallback(async () => {
        const {docGuid} = curDocument;
        const ksServer = await sdk.getKsServer(curRepository);
        const docCoins = await ksServer.giveCoinsList(docGuid) || [];
        // 将知识币的更新同步到store
        store.setCurDocKnowledgeCoin(docCoins.length);
    }, [curDocument, curRepository]);

    useEffect(() => {
        // 新建的文档且处于编辑模式，会获取知识币
        if (mode !== EDITOR_MODE.preview) {
            updateKnowledgeCoins();
        }
    }, [updateKnowledgeCoins, mode]);

    let rootStyle = {};
    if (docContentWidth) {
        rootStyle = {
            width: docContentWidth.width,
            left: docContentWidth.left,
        };
    }

    return (
        <div id="doc-bottom-bar-wrap" className={styles.bottomBarWrap}>
            <div
                className={classNames(
                    styles.bottomBar,
                    aiChatPanel?.isExpanded && styles.fitAiChat,
                    aiChatPanel?.isAiAssistant && styles.isAiAssistant
                )}
            >
                <div className={styles.root} style={rootStyle}>
                    <div className={styles.left} ref={leftElRef}>
                        <leftElResizeContext.Provider value={leftElResizeFlag}>
                            {
                                kuPiper.openNormalReplaceSlot(
                                    {
                                        scope: kuPiper.slotScopeMap.DocumentEditor,
                                        position: kuPiper.slotPositionMap.DocumentEditor.Tag,
                                        DefaultComponent: <TagWrap
                                            editable={editable}
                                            curDocument={curDocument}
                                            curRepository={curRepository}
                                            rootId={rootId}
                                        />,
                                    }
                                )
                            }
                        </leftElResizeContext.Provider>
                    </div>
                    <div className={styles.placeholder}></div>
                    <div className={styles.right}>
                        {isStatNumShow ? (
                            <>
                                {/* 文档字数小流量下线 */}
                                {
                                    <StatisticCount
                                        docWordNum={docWordNum}
                                        documentMode={mode}
                                        demoMode={demoMode}
                                    />
                                }
                                {/* // 未开启浏览详情记录： */}
                                {
                                    (!isCloseRecentBrowseRecords || closeRecentBrowseRecords)
                                        ? <ViewNumber
                                            icon={ReadNumberSvg}
                                            title={
                                                intl.formatMessage(
                                                    {id: 'pageViewNumber'},
                                                    {number: curDocument?.pageView}
                                                )
                                            }
                                            number={curDocument?.pageView}
                                        />
                                        : null
                                }
                                {/* 功能开启，普通成员查看 */}
                                {
                                    (isCloseRecentBrowseRecords && !editable)
                                        ? <ViewNumberIsLookToMember
                                            icon={ReadNumberSvg}
                                            title={intl.formatMessage({id: 'noPermissionPrompt'})}
                                            number={curDocument?.pageView}
                                        />
                                        : null
                                }
                                {/* 功能开启，管理员和可编辑成员查看 */}
                                {
                                    (isCloseRecentBrowseRecords && editable && !closeRecentBrowseRecords)
                                        ? <ViewNumberIsLookToAdministrators
                                            icon={ReadNumberSvg}
                                            number={curDocument?.pageView}
                                            setIsOpenAllRecentBrowseRecords={setIsOpenAllRecentBrowseRecords}
                                            repositoryGuid={curRepository.repositoryGuid}
                                            docGuid={curDocument?.docGuid}
                                            setcloseRecentBrowseRecords={setcloseRecentBrowseRecords}
                                        />
                                        : null
                                }
                                <ViewNumber
                                    icon={CommentNumberSvg}
                                    title={intl.formatMessage({id: 'commentsNumber'}, {number: commentNum})}
                                    number={commentNum}
                                />
                                {(!isBaikeRepo) ? <ViewKnowledgeCoin
                                    repository={curRepository}
                                    icon={CoinBottomBar}
                                    number={knowledgeCoinNum}
                                    curDocument={curDocument}
                                    documentMode={mode}
                                /> : null}
                            </>
                        ) : null}
                    </div>
                    <RecentBrowseRecordsConfirmDialog
                        isOpenAllRecentBrowseRecords={isOpenAllRecentBrowseRecords}
                        pageView={curDocument?.pageView}
                        docGuid={curDocument?.docGuid}
                        setIsOpenAllRecentBrowseRecords={setIsOpenAllRecentBrowseRecords}
                        repositoryGuid={curRepository.repositoryGuid}
                    />
                    {
                        // 知识库文档投诉 前端小流量代码下线
                        <>
                            <div className={styles.divider}></div>
                            <Tooltip
                                trigger={TooltipTrigger.Hover}
                                content={'投诉文档'}
                            >
                                <div
                                    className={classNames(styles.complainBtn, isCardView && styles.complainBtnCardView)}
                                    onClick={() => {
                                        setComplainVisible(true);
                                        feLogger(reportDocComplainBtn({
                                            pageId: curDocument?.docGuid || '', source: 'bottomBar',
                                        }));
                                    }}
                                >
                                    <span className={styles.complainIcon}></span>
                                    <span>投诉</span>
                                </div>
                            </Tooltip>
                        </>
                    }
                    {
                        complainVisible ? (
                            <ComplainDialog onCancel={() => setComplainVisible(false)} />
                        ) : null
                    }
                </div>
            </div>
        </div>
    );
};

export default store.connect([
    store.KEYS.IS_STAT_NUM_SHOW,
    store.KEYS.CUR_DOCUMENT_COMMENT_COUNT,
    store.KEYS.DOC_CONTENT_WIDTH,
    store.KEYS.CUR_DOCUMENT_KNOWLEDGE_COIN,
    store.KEYS.DOCUMENT_MODE,
    store.KEYS.AI_CHAT_PANEL,
    store.KEYS.PAGE_SECURITY_SETTINGS,
    store.KEYS.DOC_WORD_NUM,
    store.KEYS.DEMO_MODE,
])(BottomBar);
